import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const addFavorite = async (cleanerId: string) => {
  await apiClient.post(ENDPOINTS.FAVORITES, {
    cleanerId,
  });
};
